import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_135: DocMigration = {
  maxSchemaVersion: "0.0.135",
  description: "Ensure that any orphaned groups are removed",
  apply(json: any, warnings: string[]) {
    const validGroupIds = Object.values(json.entityGroups ?? {});

    if (json.groups && !Object.keys(json.groups).length) {
      json.entityGroups = {};
    }

    for (const id in json.groups) {
      const group = json.groups[id];

      if (validGroupIds.indexOf(id) === -1) {
        warnings.push(`Orphaned group ${group.name} has been removed as it does not contain any entities`);
        delete json.groups[id];
      }
    }

    return json;
  },
};

export default migration_0_0_135;
